import { Routes } from '@angular/router';

import { HomeComponent } from './04-pages/home/home.component';
import { ContactoComponent } from './04-pages/contacto/contacto.component';
import { NosotrosComponent } from './04-pages/nosotros/nosotros.component';
import { InstitucionalComponent } from './04-pages/institucional/institucional.component';
import { EstadoViaComponent } from './04-pages/estado-via/estado-via.component';
import { PicoyplacaComponent } from './04-pages/picoyplaca/picoyplaca.component';
import { ServiciosComponent } from './04-pages/servicios/servicios.component';
import { TarifasComponent } from './04-pages/tarifas/tarifas.component';
import { NoticiaComponent } from './04-pages/noticia/noticia.component';
import { NoticiasComponent } from './04-pages/noticias/noticias.component';
import { ImporteComponent } from './04-pages/importe/importe.component';
import { DocumentoEquivalenteComponent } from './04-pages/documento-equivalente/documento-equivalente.component';

export const PatternsRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'noticias', component: NoticiasComponent },
  { path: 'noticias/:id', component: NoticiaComponent },
  { path: 'nosotros', component: NosotrosComponent },
  { path: 'contacto', component: ContactoComponent },
  { path: 'institucional', component: InstitucionalComponent },
  { path: 'picoyplaca', component: PicoyplacaComponent },
  { path: 'servicios', component: ServiciosComponent },
  { path: 'importes', component: ImporteComponent },
  { path: 'tarifas', component: TarifasComponent },
  { path: 'estado-via', component: EstadoViaComponent },
  { path: 'documento', component: DocumentoEquivalenteComponent },
];
